import { ReactElement, useEffect, useMemo } from 'react';
import { TabsProps } from 'antd';
import { useTranslation } from 'react-i18next';

import { Page, StyledTabs } from '@ohpen/enso-ui';
import { FeesTab, FeeProfilesTab, FEES_VALUE_LIST_NAMES, getFeeOptions } from '@pmp/components';
import { usePmpFetch } from '@pmp/hooks';
import { useValueListsStore } from '@pmp/stores';

export const FeesPage = (): ReactElement => {
  const [isFetching, , fees, , fetchFees] = usePmpFetch('feeDefinitionsGetAllFeeDefinitions');
  const { valueLists, getValueLists } = useValueListsStore();
  const { t } = useTranslation();

  useEffect(() => {
    getValueLists({ fetchIfMissing: FEES_VALUE_LIST_NAMES });
  }, [getValueLists]);

  useEffect(() => {
    fetchFees();
  }, [fetchFees]);

  const tabItems: TabsProps['items'] = useMemo(() => {
    const feeProfilesValueLists = { ...valueLists, FEES: fees ? getFeeOptions(fees) : {} };
    const items = [
      {
        key: 'fees',
        label: t('pmp.fees.labels.feesList'),
        children: <FeesTab valueLists={valueLists} data={fees} isFetching={isFetching} fetchData={fetchFees} />,
      },
      {
        key: 'profiles',
        label: t('pmp.fees.labels.feeProfiles'),
        children: <FeeProfilesTab valueLists={feeProfilesValueLists} />,
      },
    ];

    return items;
  }, [valueLists, fees, t, isFetching, fetchFees]);

  return (
    <Page>
      <Page.Title>{t('pmp.fees.title')}</Page.Title>
      <Page.Content>
        <StyledTabs defaultActiveKey="fees" items={tabItems} />
      </Page.Content>
    </Page>
  );
};
